export const DISPLAY_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_DATE_FORMAT = 'MM-DD-YYYY';
export const END_OF_YEAR_FORMAT = 'MM-DD';
